import PropTypes from 'prop-types';
import { ModalDialog } from '@zillow/constellation';
import { WizardContent, WizardProvider } from '@zillow/zrs-rental-applications';
import ApplicationManagerFooter from './ApplicationManagerFooter/ApplicationManagerFooter';
import LandingStep from './LandingStep';
import NameStep from './NameStep';
import SuccessStep from './SuccessStep';
import AccessUnavailableStep from './AccessUnavailableStep';
import ErrorStep from './ErrorStep';
import { ERROR_STEP } from './ApplicationManagerModal.util';

export default function ApplicationManagerModal({ isOpen, onClose, street, employees = [] }) {
  return (
    <ModalDialog
      renderHeader="Permissions setup"
      renderBody={
        <WizardContent>
          <LandingStep id="landing" employees={employees} />
          <NameStep id="name" />
          <SuccessStep id="success" employees={employees} street={street} />
          <AccessUnavailableStep id="accessUnavailable" />
          <ErrorStep id={ERROR_STEP} />
        </WizardContent>
      }
      renderFooter={(footerProps) => (
        <ApplicationManagerFooter onClose={onClose} employees={employees} footerProps={footerProps} />
      )}
      renderLayout={(layoutProps, rootProps, layoutOptions) => {
        return <WizardProvider>{layoutOptions.default}</WizardProvider>;
      }}
      isOpen={isOpen}
      onClose={onClose}
      size={{ default: 'fullScreen', lg: 'md' }}
    />
  );
}

ApplicationManagerModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  street: SuccessStep.propTypes.street,
  employees: PropTypes.array,
};
